import { toastr } from "react-redux-toastr"
import { getPca } from "../authProvider"

export const handleResponse = (response: any, translations: any) => {
  switch (response.status) {
    case 700:
      response.json().then((res: any) => {
        toastr.error(res.Text, "")
      })
      break
    case 200:
      break
    case 204:
      // No content is a success: nothing to display.
      break
    case 201:
      toastr.info(translations.header201, translations.message201)
      break
    case 400:
      toastr.error(translations.header400, translations.message400)
      break
    case 401:
      const toastrConfirmOptions = {
        okText: translations.confirmReconnect,
        cancelText: translations.cancelReconnect,
        onOk: () => getPca().loginRedirect(),
        onCancel: () => getPca().logoutRedirect(),
      }
      toastr.confirm(translations.sessionReconnect, toastrConfirmOptions)
      // toastr.error(translations.header401, translations.message401, {
      //   showCloseButton: false,
      //   onHideComplete: () => authentication.signOut(),
      //   onToastrClick: () => authentication.signOut()
      // })
      break
    case 500:
      toastr.error(translations.header500, translations.message500)
      break
    default:
      if (response[0] !== undefined) {
        if (response[0].status === 200) {
          break
        }
      } else {
        response.text().then((text: string) => {
          if (text.length > 30) {
            toastr.error(translations.header500, translations.message500)
          } else {
            toastr.error(text, "")
          }
        })
      }
      break
  }
}

export enum responseType {
  json,
  text,
  blob,
  void,
}

/**
 * This function will decompose the response of any request sent to the server.
 * We had to add the parameter "translations" to this function since this fonction can't access the reducer in which the texts are contained.
 * @param res
 * @param translations - typically "getTranslationsByScope(getState(), "toastrLabels")" when called in an action
 * @param type
 */
export const transform = (res: any, translations: any, type?: responseType) => {
  handleResponse(res, translations)

  if (res.status >= 300) {
    if (res.status === 401) {
      throw translations.header401
    }
    throw new Error()
  }

  switch (type) {
    case responseType.json:
      // 204 No Content has no body to parse.
      return res.status === 204 ? null : res.json()
    case responseType.text:
      if (res[0] !== undefined) {
        return res[0].text()
      } else {
        return res.text()
      }
    case responseType.blob:
      return res.blob()
    case responseType.void:
      return true
    default:
      return "No transform type provided"
  }
}
